
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/connect-wallet",
      function () {
        return require("private-next-pages/connect-wallet/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/connect-wallet"])
      });
    }
  